import React, {useState, useRef, useMemo} from 'react';
import Utility from '../../../util/utilityfunctions';
import TextAreaEditorWrapper from '../../Common/TextAreaEditor/TextAreaEditor';
import {entities, canvasFormBannerTypes} from '../../../util/uiconstants';
import styled from 'styled-components';
import EditModal from '../../Common/Modal/EditModal';
import EditControlContainer from './EditControlContainer';
import EditITControlContainer from './EditITControlContainer';
import EditRiskContainer from './EditRiskContainer';
import env from '../../../util/env';
import {serviceURL} from '../../../util/uiconstants';
import {updateWcgw} from '../../../actions/WCGW/wcgwactions';
import {updateControl} from '../../../actions/Control/controlaction';
import {updateITControl} from '../../../actions/ITControl/itcontrolaction';
import {useDispatch} from 'react-redux';
import {updateRelatedObject} from '../../../actions/RelatedObjects/relatedobjectsactions';
import {updateItProcess} from '../../../actions/ITProcess/itprocessactions';
import {updateItApplication} from '../../../actions/ITApplication/itapplicationaction';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import EditITApplicationContainer from './EditITApplicationContainer';
import {labels} from '../../../util/utils';
import {updateFormBodyRelatedObject} from '../../../actions/FormData/formdataactions';
import {updateSectionRelatedObject} from '../../../actions/RelatedObjects/relatedobjectsactions';
import {updateRisk} from '../../../actions/Risk/riskactions';
import CanvasBanner from '../../Common/CanvasForm/Banner/CanvasBanner';

export function EditADCContainer(props) {
	const {
		bodyId,
		item,
		documentEngagementId,
		engagementId,
		documentId,
		objectEntityId,
		showHideModel,
		parentName
	} = props;
	const existingRiskTypeId = item?.riskTypeId ?? item?.additionalData?.riskTypeId;
	const existingStrategyTypeId = item?.strategyTypeId ?? item?.additionalData?.strategyTypeId;

	const [error, setError] = useState(''),
		[showLoader, setShowLoader] = useState(false),
		[name, setName] = useState(item.name || item.entityName),
		[strategyTypeId, setStrategyTypeId] = useState(existingStrategyTypeId),
		[riskTypeId, setRiskTypeId] = useState(existingRiskTypeId);

	const dispatch = useDispatch();

	const scotContainerRef = useRef({});
	const controlContainerRef = useRef({});
	const itAppContainerRef = useRef({});

	const ADCContainerRef = useRef({});

	const parentEntityName = parentName || item.parentEntityName;

	const nameChange = (e) => {
		setError('');
		setName(e.currentTarget.value);
	};

	const strategyTypeChange = (e) => {
		setStrategyTypeId(Number(e.currentTarget.value));
	};

	const riskTypeChange = (option) => {
		setRiskTypeId(Number(option.id));
	};

	const saveNameChange = () => {
		if (!name || name.trim().length === 0) {
			setError(labels.nameRequired);
		} else {
			setShowLoader(true);
			saveChanges();
		}
	};

	//  Do not show objects in edit mode
	const disableEditFeature = (e) => {
		return Number(engagementId) !== Number(documentEngagementId);
	};

	// update store for form details RelatedObjects
	const updateFormDetailRelatedObjects = (entityId, id, entityName) => {
		let dataModel;
		if (strategyTypeId) {
			dataModel = {
				entityId: entityId,
				id: id,
				entityName: entityName,
				strategyTypeId: strategyTypeId
			};
		} else if (riskTypeId) {
			dataModel = {
				entityId: entityId,
				id: id,
				entityName: entityName,
				riskTypeId: riskTypeId
			};
		} else {
			dataModel = {
				entityId: entityId,
				id: id,
				entityName: entityName
			};
		}
		dispatch(updateRelatedObject(dataModel)).then(() => {
			showHideModel(false);
			setShowLoader(false);
		});
	};

	// update form detail, special body and FSRO store based on which item is editing.
	const updateRequiredStore = (entityUId, entityName, item, updatedData) => {
		if (bodyId && bodyId > 0) {
			dispatch(
				updateFormBodyRelatedObject({
					bodyId: bodyId,
					entityId: item.entityId,
					entityUId: entityUId,
					entityName: entityName,
					riskTypeId: riskTypeId,
					strategyTypeId: updatedData ? updatedData?.strategyTypeId : strategyTypeId,
					controlFrequencyTypeId: updatedData?.controlFrequencyTypeId,
					controlTypeId: updatedData?.controlTypeId,
					iTApplications: updatedData?.iTApplications,
					designEffectiveness: updatedData?.controlDesignEffectivenessTypeId,
					isEffective: updatedData?.isEffective,
					hasControlTesting: updatedData?.hasControlTesting,
					isLowerRisk: updatedData?.isLowerRisk,
					itApproachTypeId: updatedData?.itApproachTypeId,
					hasitcontroltesting: updatedData?.hasControlTesting
				})
			).then(() => {
				showHideModel(false);
			});
		} else if (item.formSectionId && item.formSectionId > 0) {
			dispatch(
				updateSectionRelatedObject({
					sectionId: item.formSectionId,
					entityId: item.entityId,
					entityUId: item.entityUId,
					entityName: entityName,
					riskTypeId: riskTypeId,
					strategyTypeId: strategyTypeId,
					controlFrequencyTypeId: updatedData?.controlFrequencyTypeId,
					controlTypeId: updatedData?.controlTypeId,
					iTApplications: updatedData?.iTApplications,
					designEffectiveness: updatedData?.controlDesignEffectivenessTypeId,
					isEffective: updatedData?.isEffective,
					hasControlTesting: updatedData?.hasControlTesting,
					isLowerRisk: updatedData?.isLowerRisk,
					itApproachTypeId: updatedData?.itApproachTypeId,
					hasitcontroltesting: updatedData?.hasControlTesting
				})
			).then(() => {
				showHideModel(false);
			});
		} else {
			updateFormDetailRelatedObjects(item.entityId, entityUId, entityName);
		}
	};

	const saveChanges = () => {
		let entityName = name.trim(),
			entityUId;
		switch (item.entityId) {
			case entities.WCGW:
				entityUId = objectEntityId;
				dispatch(updateWcgw(env.getBaseURL(serviceURL, engagementId) + `Wcgws/${Number(entityUId)}`, {wcgwName: name}))
					.then(() => {
						//updateFormDetailRelatedObjects(item.entityId, entityUId, entityName);
						updateRequiredStore(entityUId, entityName, item);
					})
					.catch(() => {
						setShowLoader(false);
					});
				break;
			case entities.ItProcess: {
				entityUId = item.id;

				const payload = {
					itprocessName: entityName
				};

				dispatch(updateItProcess(engagementId, payload, entityUId))
					.then(() => {
						updateFormDetailRelatedObjects(item.entityId, entityUId, entityName);
					})
					.catch(() => {
						setShowLoader(false);
					});
				break;
			}
			case entities.ItSoApplication: {
				entityUId = item?.id ? item.id : item.entityUId;
				const itAppDetails = {
					id: Number(entityUId),
					iTApplicationName: entityName,
					strategyTypeId: strategyTypeId
				};

				dispatch(updateItApplication(engagementId, entityUId, itAppDetails))
					.then(() => {
						updateRequiredStore(entityUId, entityName, item);
					})
					.catch(() => {
						setShowLoader(false);
					});
				break;
			}
			case entities.Control: {
				entityUId = objectEntityId;

				let selectedControlContainerRef = controlContainerRef.current.selectedControl;
				let controlData = {
					id: Number(entityUId),
					controlName: entityName,
					controlFrequencyTypeId:
						selectedControlContainerRef.controlFrequencyTypeId === 'none'
							? null
							: selectedControlContainerRef.controlFrequencyTypeId,
					controlTypeId:
						selectedControlContainerRef.controlTypeId === 'none' ? null : selectedControlContainerRef.controlTypeId,
					iTApplications: selectedControlContainerRef.iTApplications,
					controlDesignEffectivenessTypeId: selectedControlContainerRef.controlDesignEffectivenessTypeId,
					isEffective: selectedControlContainerRef.isEffective,
					hasControlTesting: selectedControlContainerRef.hasControlTesting,
					isLowerRisk: selectedControlContainerRef.isLowerRisk,
					isIPEManuallyTested: selectedControlContainerRef.isIPEManuallyTested
				};

				dispatch(updateControl(engagementId, Number(entityUId), controlData))
					.then(() => {
						updateRequiredStore(entityUId, entityName, item, controlData);
					})
					.catch((e) => {
						setShowLoader(false);
					});
				break;
			}
			case entities.ItControl: {
				entityUId = objectEntityId;
				let ContainerRef = ADCContainerRef.current.selectedControl;
				let itControlData = {
					id: Number(entityUId),
					itcontrolname: entityName,
					controlFrequencyTypeId: ContainerRef.controlFrequencyTypeId,
					itApproachTypeId: ContainerRef.itApproachTypeId,
					isEffective: ContainerRef.isEffective,
					hasitcontroltesting: ContainerRef.hasControlTesting
				};

				dispatch(updateITControl(engagementId, Number(entityUId), itControlData))
					.then(() => {
						updateRequiredStore(entityUId, entityName, item, itControlData);
					})
					.catch((e) => {
						setShowLoader(false);
					});
				break;
			}
			case entities.Risk: {
				entityUId = item?.documentEntityId ? item?.id : item?.entityUId;
				let riskDetails = {
					id: Number(entityUId),
					riskName: entityName,
					riskTypeId: riskTypeId
				};

				dispatch(updateRisk(engagementId, riskDetails))
					.then(() => {
						updateRequiredStore(entityUId, entityName, item);
					})
					.catch((e) => {
						setShowLoader(false);
					});
				break;
			}
		}
	};

	const GetADCContainer = useMemo(() => {
		switch (item.entityId) {
			case entities.ItControl: {
				let itControlId = objectEntityId;
				return (
					<EditITControlContainer
						ADCContainerRef={ADCContainerRef}
						isShared={Number(engagementId) !== Number(documentEngagementId)}
						scotContainerRef={scotContainerRef}
						controlId={Number(itControlId)}
						engagementId={engagementId}
						documentId={documentId}
						entityId={item.entityId}
					/>
				);
			}
			case entities.Control: {
				let controlId = objectEntityId;
				return (
					<EditControlContainer
						controlContainerRef={controlContainerRef}
						isShared={Number(engagementId) !== Number(documentEngagementId)}
						scotContainerRef={scotContainerRef}
						controlId={Number(controlId)}
						engagementId={engagementId}
						documentId={documentId}
						entityId={item.entityId}
					/>
				);
			}
			case entities.ItSoApplication: {
				return (
					<EditITApplicationContainer
						item={item}
						bodyId={bodyId}
						strategyTypeId={strategyTypeId}
						isShared={disableEditFeature()}
						itAppContainerRef={itAppContainerRef}
						documentEngagementId={documentEngagementId}
						strategyTypeChange={strategyTypeChange}
					/>
				);
			}
			case entities.Risk:
				return (
					<EditRiskContainer
						isShared={Number(engagementId) !== Number(documentEngagementId)}
						riskTypeChange={riskTypeChange}
						riskTypeId={riskTypeId}
					/>
				);
		}
	});

	return (
		<Wrapper className={`recursive-list__item Level`}>
			{showLoader ? (
				<LoadingIndicator show view="blockview" styleName="LoadingIndicator" />
			) : (
				<EditModal
					show
					showLoader={showLoader}
					showButtons
					confirmBtnTitle={labels.saveLabel}
					closeTitle={labels.closeLabel}
					cancelBtnTitle={labels.cancelLabel}
					title={Utility.getAdcModalTitle(item.entityId, disableEditFeature())}
					body={
						<section className="editADCWrapper editWcgwWrapper customScrollbar">
							<section className="SharedBannerWrapper">
								{disableEditFeature() ? (
									<CanvasBanner documentId={documentId} bannerType={canvasFormBannerTypes.shared} editAdcBanner />
								) : (
									<span className="AdcModalDescriptionTitle">{Utility.getAdcModalDescriptionTitle()}</span>
								)}
							</section>
							{item.entityId === entities.WCGW && <section className="editAdcParentName">{parentEntityName}</section>}
							<TextAreaEditorWrapper
								textAreaEditorLabel={labels.name}
								maxLength={500}
								value={name}
								className="editAdcTextArea"
								isDisabled={disableEditFeature()}
								onChange={nameChange}
								textAreaError={error.length > 0}
								textAreaErrorMessage={error}
							/>
							{GetADCContainer}
						</section>
					}
					onHide={() => {
						showHideModel(false);
					}}
					onConfirmClick={saveNameChange}
					showConfirm={!disableEditFeature()}
					modalSize="medium"
				/>
			)}
		</Wrapper>
	);
}

export default EditADCContainer;

const Wrapper = styled.section`
	.scotStrategyText {
		font-size: var(--px-14);
		font-weight: 300;
		color: var(--neutrals-900);
		margin-bottom: var(--px-8);
	}
	.scotStrategyContentSwitcher {
		display: flex;
		margin-bottom: var(--px-20);
		.motif-content-switcher {
			button {
				.ellipses {
					justify-content: center;
				}
			}
		}
	}
	.scotTypeSelect {
		display: flex;
		width: var(--px-360);
		margin-bottom: var(--px-20);
		.selectText {
			display: flex;
			width: 100%;
			align-items: center;
			line-height: normal;
		}
		.react-select-container {
			.react-select__control {
				.react-select__value-container--is-multi {
					margin-top: var(--px-10);
					line-height: normal;
				}
				.react-select__multi-value {
					align-items: center;
					max-width: var(--px-100);
					margin-top: var(--px-5);
					.react-select__multi-value__label {
						padding: var(--px-3) var(--px-3) var(--px-3) var(--px-6);
					}
				}
				.react-select__multi-value__remove {
					height: auto;
				}
			}
		}
	}
	.relatedITSelect {
		display: flex;
		width: var(--px-650);
		.selectText {
			display: flex;
			width: 100%;
			align-items: center;
			line-height: normal;
		}
		.react-select-container {
			.react-select__control {
				.react-select__value-container--is-multi {
					margin-top: var(--px-15);
					line-height: normal;
				}
				.react-select__multi-value {
					align-items: center;
					max-width: var(--px-100);
					margin-top: var(--px-5);
					.react-select__multi-value__label {
						padding: var(--px-3) var(--px-3) var(--px-3) var(--px-6);
					}
				}
				.react-select__multi-value__remove {
					height: auto;
				}
			}
		}
	}
`;
